import React, { useCallback } from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import bowser from 'yola-bowser';

import Tooltip from '../tooltip';
import SelectedIcon from '../selected-icon';

const PreviewContainer = ({
  title = '',
  description = '',
  tooltipText = '',
  selected = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onPreviewClick = null,
  children,
}) => {
  const isMobile = bowser.mobile;
  const isTablet = bowser.tablet;
  const isTouchDevice = isMobile || isTablet;
  const isTooltipEnabled = !!tooltipText;
  const tooltipId = `preview-container_${uuid()}`;
  const tooltipAttrsForButton = {
    'data-tip': true,
    'data-for': tooltipId,
  };
  const classes = classNames('ws-ui-preview-container__media-box', {
    'ws-ui-preview-container__media-box--selected': selected,
    'ws-ui-preview-container__media-box--clickable': onPreviewClick,
    'ws-ui-preview-container__media-box--touch-device': isTouchDevice,
  });

  const handleClick = useCallback(() => {
    if (onPreviewClick) {
      onPreviewClick();
    }
  }, [onPreviewClick]);

  return (
    <div className="ws-ui-preview-container">
      <div
        className={classes}
        onClick={handleClick}
        {...(isTooltipEnabled && tooltipAttrsForButton)}
      >
        {selected && (
          <div className="ws-ui-preview-container__selected-icon">
            <SelectedIcon />
          </div>
        )}
        {isTooltipEnabled && <Tooltip text={tooltipText} type="float" id={tooltipId} />}
        <div className="ws-ui-preview-container__content">{children}</div>
      </div>
      {title && <p className="ws-ui-preview-container__title">{title}</p>}
      {!title && description && (
        <p className="ws-ui-preview-container__description">{description}</p>
      )}
    </div>
  );
};

export default PreviewContainer;
